import { Component, signal, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';
import { HeaderParametersValues } from 'src/app/shared/models/data/headerParametersValues.model';
import { Items, ItemsByEnquiryNo } from 'src/app/shared/models/data/itemsByEnquiryNo.model';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { UserConfiguration } from 'src/app/shared/models/data/userConfiguration.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { ActiveFilter, CalculatedCols, CustomIcoCol, GridConfiguration, MenuVoice } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { GridDataset } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { TeiasoftModalReturnObject } from 'src/app/shared/teiasoft-bucket/teiasoft-modal/teiasoft-modal.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';

@Component({
  selector: 'app-enquiry-book-pricing-committee',
  templateUrl: './enquiry-book-pricing-committee.component.html',
  styleUrl: './enquiry-book-pricing-committee.component.scss',
  standalone: false,
})
export class EnquiryBookPricingCommitteeComponent {
  private readonly gridConfigurationName: string = 'FrozenEnquiryBook';
  oDataUrl: string = "Enquiries";
  columnsToHide: string[] = ['Id', "DueDateColor", "UserId", "SalesOfficeId", 'CostsStatus', 'FeasibilityStatus', 'DeliveryStatus', 'QuotationExists', 'IsQuotationFinal', 'IsQuotationExternallyUploaded', 'OdUom', 'IdUom', 'WtUom', 'TotalWeightUom'];
  columnsToShowRowExpand: string[] = ["customerItemNo", "feasibilityStatus", "costsStatus", "deliveryStatus", "unitSystem", "material.materialCode", "sms.description", "marketFamily.name", "customerDeliveryDate", "energySurcharge", "applicableNorms", "remark", "normGrades.normGradeCode", "gradeCustomerAnalysisLimitation.limitation",
    "gradeCustomerOtherLimitation.limitation", "rawMaterialGrade.rawMaterialGradeCode", "npsSchedule.npsDescription", "od", "odTolerancePlus", "odToleranceMinus", "odToleranceUom", "id", "idTolerancePlus", "idToleranceMinus", "idToleranceUom", "wt", "typeOfTolerance", "tubeExecution.description", "wtTolerancePlus", "wtToleranceMinus", "wtToleranceUom",
    "quantity", "quantityUom", "lengthType", "multipleLength", "lengthMin", "lengthMax", "lengthNominal", "lengthUom", "uBent", "totalWeight", "totalWeightUom", "mill.shortName", "surfaceType.name", "cts", "endsCondition", "testCondition", "sql.name", "offerScheme.offerSchemeDescription", "ut", "hydroTest", "ht", "htAdditional", 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting',
    "icrIssued", "itrIssued", "idrIssued", "attachments", "fullCost", "extraCosts", "minimumFm", "recommendedFm", "customerBonus", "minimumPrice", "recommendedPrice", "actualFm", "negotiationMargin", "agentFee", "finalPrice", 'finalPricePerLength', 'alloySurchargeValue', 'energySurchargeValue', "initialPrice", "previousRevisionPrice", "extraLeadTime", "deliveryDate"];

  customIcoCols: CustomIcoCol[] = new Array();
  gridConfiguration: GridConfiguration = new GridConfiguration();
  showFilters: boolean = false;
  clearFilters: boolean = false;
  showSettingsDialog: boolean = false;
  enquiryItems: any;
  dataSetItems: any[] = new Array();
  expandedEnquiryNo: string = "";
  buttonsList: TTButton[] = new Array();
  isDataFiltered: boolean = false;
  calculatedCols: CalculatedCols[] = new Array();
  refreshGridKey: number = 0;
  roundDigitsForGrid: RoundDigit[] = new Array();
  roundDigitsForItemGrid: RoundDigit[] = new Array();
  headerParametersValues: HeaderParametersValues = new HeaderParametersValues();
  filtersToHide: string[] = ["NumberOfAttachments"];

  @ViewChild('viewCost', { static: true }) viewCostTemplate!: TemplateRef<any>;
  @ViewChild('viewExtraCosts', { static: true }) viewExtraCostsTemplate!: TemplateRef<any>;
  @ViewChild('viewDeliveryDates', { static: true }) viewDeliveryDates!: TemplateRef<any>;

  customRenderers = {
    initialPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'initialPrice' }
      };
    },
    previousRevisionPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPricePerLength', uomColumn: 'finalPricePerLengthUom' }
      };
    },
    deliveryDate: (row: any) => {
      return {
        template: this.viewDeliveryDates,
        context: { $implicit: row, column: 'delilveryDate' }
      };
    },
    alloySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'alloySurchargeValue' }
      };
    },
    energySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'energySurchargeValue' }
      };
    },
    fullCost: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'fullCost' }
      };
    },
    minimumPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'minimumPrice' }
      };
    },
    recommendedPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'recommendedPrice' }
      };
    },
    extraCosts: (row: any) => {
      return {
        template: this.viewExtraCostsTemplate,
        context: { $implicit: row }
      };
    },
    finalPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPrice' }
      };
    }
  };

  constructor(public globals: Globals, private translate: TranslateService, private utils: UtilsService, private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService, private teiasoftModalService: TeiasoftModalService) {
    this.getRoundDigits();
    this.getHeaderParametersValues();
    this.loadUserConfiguration();
    this.gridConfiguration.defaultFilterView = 'getFrozen';

  }

  async getHeaderParametersValues() {
    try {
      const res = await firstValueFrom(this.backendService.getHeaderParametersValues());
      if (!res) return;

      res.countries?.sort((a, b) => {
        if (a.countryName! < b.countryName!) return -1;
        if (a.countryName! > b.countryName!) return 1;
        return 0;
      });

      this.headerParametersValues = res;
    } catch (_err) {
    }
  }

  loadUserConfiguration() {
    this.gridConfiguration = new GridConfiguration();
    const userConfiguration: UserConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === this.gridConfigurationName);

    if (savedConfiguration) {
      this.gridConfiguration = savedConfiguration;
    } else {
      this.gridConfiguration = new GridConfiguration();
      this.gridConfiguration.name = this.gridConfigurationName;
      this.gridConfiguration.defaultFilterView = 'getFrozen';
    }

    if (!this.gridConfiguration.name) {
      this.gridConfiguration.name = this.gridConfigurationName;
    }

    if (!this.gridConfiguration.defaultFilterView) {
      this.gridConfiguration.defaultFilterView = 'getFrozen';
    }

    this.buildCustomIconGrid();
    this.buildButtonsList();
    this.buildCalculatedCols();
  }

  getRoundDigits() {
    this.teiasoftLoader.start();
    this.utils.getRoundDigits().subscribe(res => {
      this.roundDigitsForGrid = new Array();
      this.roundDigitsForGrid = res.filter(x => x.section == 'Enquiries' && x.api == 'GetEnquiries');
      this.roundDigitsForItemGrid = new Array();
      this.roundDigitsForItemGrid = res.filter(x => x.section == 'EditEnquiryItem' && x.api == 'EditAndCreateVersionIfNecessary');

    });
  }

  buildCustomIconGrid() {
    this.customIcoCols = new Array();

    /* OPEN ACTION ON ENQUIRY MENU*/
    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = '';
    _item.icon = new Array();
    _item.icon = ['fal fa-ellipsis-h'];
    _item.tooltip = "grid.openEnqActions";
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = true;
    _item.menuVoices = new Array();

    let _voice: MenuVoice = new MenuVoice();
    _voice.text = "enquiryBook.acceptEnquiry";
    _voice.action = "acceptEnquiry";
    _voice.icon = 'fas fa-check';
    _item.menuVoices.push(_voice);
    _voice = new MenuVoice();
    _voice.text = "enquiryBook.refuseEnquiry";
    _voice.icon = 'fas fa-times';
    _voice.action = "refuseEnquiry";
    _item.menuVoices.push(_voice);


    this.customIcoCols.push(_item);


    /* EXPAND ROW */
    _item = new CustomIcoCol();
    _item.action = "expandRow|Items"; // Flag that expand the single row | object to expand
    _item.icon = new Array();
    _item.icon = ['fal fa-plus', 'fal fa-minus'];
    _item.tooltip = this.translate.instant("grid.openItems");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.customIcoCols.push(_item);

  }

  buildCalculatedCols() {
    this.calculatedCols = new Array();
    /* FEASIBILITY CALCULATED COL */
    let _item: CalculatedCols = new CalculatedCols();
    _item.id = 0;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|FeasibilityStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "F";
    this.calculatedCols.push(_item);

    /* PRICE CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 1;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|CostsStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "P";
    this.calculatedCols.push(_item);

    /* DELIVERY CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 2;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|DeliveryStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "D";
    this.calculatedCols.push(_item);


  }


  customIconClick(evt: any) {

    if (evt.indexOf("|") != -1) {
      const { action: _action, row: _obj } = parseGridActionEvent(evt);

      if (_action == 'expandRow') {
        this.expandedEnquiryNo = '';
        this.enquiryItems = new ItemsByEnquiryNo();
        this.dataSetItems = new Array();
        this.getItemsByEnquiryNo(_obj["EnquiryNo"]);
      }

      if (_action == 'acceptEnquiry') {
        let _param: string = _obj["EnquiryNo"];
        let _message: string = this.translate.instant("enquiryBook.confirmAcceptEnquiry");
        this.teiasoftModalService.show('confirm', this.translate.instant("grid.acceptEnquiry"), _message, _param, 'confirmAcceptEnquiry');
      }

      if (_action == 'refuseEnquiry') {
        let _param: string = _obj["EnquiryNo"];
        let _message: string = this.translate.instant("enquiryBook.confirmRefuseEnquiry");
        this.teiasoftModalService.show('confirm', this.translate.instant("grid.refuseEnquiry"), _message, _param, 'confirmRefuseEnquiry', true);
      }
    }
  }

  buildButtonsList() {
    this.buttonsList = new Array();
    let _item: TTButton = new TTButton();

    /* EDIT GRID */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-wrench';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "editGrid";
    _item.action = "showSettingsGrid";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = !this.showFilters ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 7;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.showFilters ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.showFilters ? "showFilter" : "closeFilter";
    _item.type = '';
    _item.state = this.isDataFiltered ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.showFilters ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 8;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);


  }

  refreshFullGrid() {
    this.refreshGridKey++;
  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    const updatedConfiguration: GridConfiguration = { ...gridConfiguration, name: this.gridConfigurationName };
    this.utils.upsertGridConfiguration(updatedConfiguration);
    this.gridConfiguration = { ...updatedConfiguration }; // sync current gridConfiguration
    this.updateUserConfiguration();
  }

  updateUserConfiguration() {
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(() => {
      localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
    });
  }

  onActiveFiltersUpdate(activeFilters: ActiveFilter[]) {
    this.isDataFiltered = activeFilters.length > 0;
    this.buildButtonsList();
  }


  onBtnToolbarClick(btn: TTButton) {

    /* SHOW SETTINGS GRID */
    if (btn.action == 'showSettingsGrid') {
      this.showSettingsDialog = true;
    }

    /* SHOW FILTER */
    if (btn.action == 'showFilter') {
      this.showFilters = true;
      this.buildButtonsList();
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
      this.showFilters = false;
      this.buildButtonsList();
    }

    /* CLEAR FILTER */
    if (btn.action == 'clearFilter') {
      this.clearFilters = true;
      setTimeout(() => { this.clearFilters = false }, 250);
      this.refreshFullGrid();
    }

  }

  getItemRowMinDeliveryDate(row: EnquiryHeaderItem): string {
    const item = this.enquiryItems.items?.find((i: any) => i.itemNo === row.itemNo) as EnquiryHeaderItem;

    // Get minimum weeks value
    const minWeeks = item?.deliveryDatesCollection
      ?.map(dd => dd.deliveryNumberOfWeeksWithExtraLeadTime)
      .filter(weeks => typeof weeks === 'number' && weeks > 0)
      .reduce((min, current) => Math.min(min!, current!), Infinity);

    return minWeeks === Infinity ? '' : this.formatWeeks(minWeeks!);
  }

  formatWeeks(weeks: number): string {
    return `${weeks} week${weeks > 1 ? 's' : ''}`;
  }

  async getItemsByEnquiryNo(enquiryNo: string) {
    this.teiasoftLoader.start();
    const res = await firstValueFrom(this.backendService.getItemsByEnquiryNo(enquiryNo))
    this.enquiryItems = new ItemsByEnquiryNo();
    this.enquiryItems = res;
    this.expandedEnquiryNo = enquiryNo;
    this.fillDataSetItems(res);
  }

  fillDataSetItems(enquiryItems: ItemsByEnquiryNo) {
    this.dataSetItems = new Array();
    for (var i = 0; i < enquiryItems.items!.length; i++) {
      let _dataSet: GridDataset = new GridDataset();
      let _obj: Items = new Items();
      _obj = enquiryItems.items![i]!;
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (_value == null) _value = "";
        let _typeOf: string = typeof _value;
        let _key: string = "";
        if (_typeOf != 'object') {
          _dataSet[key] = _value;
        } else {
          if (Array.isArray(_value)) {
            _key = key;
            if (_value.length == 0) {
              _dataSet[_key] = '';
            }
            if (_value.length > 0 && key.toLowerCase() == 'attachments') {
              _dataSet[_key] = _value.length;
            } else {
              for (const key2 in _value[0]) {
                _key = key + "." + key2;
                _dataSet[_key] = _value.map(x => x[key2]).join(',');
              }
            }

          } else {
            for (const key3 in _value) {
              if (typeof _value[key3] != 'object') {
                _key = key + "." + key3;
                let _value3: any = _value[key3 as keyof typeof _value];
                _dataSet[_key] = _value3;
              } else {
                for (const key4 in _value[key3]) {
                  _key = key + "." + key3 + "." + key4;
                  let _value4: any = _value[key3][key4];
                  _dataSet[_key] = _value4;
                }
              }
            }
          }
        }
      }
      this.dataSetItems.push(_dataSet);
    }

    this.dataSetItems = this.dataSetItems.sort(
      function (a, b) {
        return a["itemNo"]! - b["itemNo"]!;
      }
    );
    this.teiasoftLoader.stop();
  }

  onConfirmModal($event: TeiasoftModalReturnObject): void {


    if ($event.closeFlag === 'confirmAcceptEnquiry') {
      const enquiryNo = $event.parameter;
      firstValueFrom(this.backendService.submitFrozenEnquiryDecision(enquiryNo, { decision: 'Accept' })).then(res => {
        this.refreshGridKey++;
      }, (_err) => {
        this.refreshGridKey++;
      });
    }

    if ($event.closeFlag === 'confirmRefuseEnquiry') {
      const enquiryNo = $event.parameter;
      firstValueFrom(this.backendService.submitFrozenEnquiryDecision(enquiryNo, { decision: 'Refuse', notes: $event.notes })).then(res => {
        this.refreshGridKey++;
      }, (_err) => {
        this.refreshGridKey++;
      });
    }

  }
}
